export type GuestLookupIntent = "return" | "tracking";

export type HeaderStoreState = {
  isOpenNavigationMenu: boolean;
  isOpenSearch: boolean;
  guestLookupIntent: GuestLookupIntent | null;
};

const INITIAL_STATE: HeaderStoreState = {
  isOpenNavigationMenu: false,
  isOpenSearch: false,
  guestLookupIntent: null,
};

let state: HeaderStoreState = INITIAL_STATE;

const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) {
    listener();
  }
}

function set(partial: Partial<HeaderStoreState>) {
  const next = { ...state, ...partial };
  if (
    next.isOpenNavigationMenu === state.isOpenNavigationMenu &&
    next.isOpenSearch === state.isOpenSearch &&
    next.guestLookupIntent === state.guestLookupIntent
  ) {
    return;
  }
  state = next;
  emit();
}

export const headerStore = {
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  getSnapshot: () => state,
  getServerSnapshot: () => INITIAL_STATE,

  openNavigationMenu: () => set({ isOpenNavigationMenu: true }),
  closeNavigationMenu: () => set({ isOpenNavigationMenu: false }),
  openSearch: () => set({ isOpenSearch: true }),
  closeSearch: () => set({ isOpenSearch: false }),
  openGuestLookup: (intent: GuestLookupIntent) =>
    set({ guestLookupIntent: intent }),
  closeGuestLookup: () => set({ guestLookupIntent: null }),

  reset: () => {
    state = { ...INITIAL_STATE };
    emit();
  },
};
